import React from 'react';
import TextField, { ITextFieldProps } from '../TextField/TextField';
import PasswordStrengthChecker from '../PasswordStrengthChecker';
import { useStyles } from './styles';

interface IPasswordFieldProps extends Omit<ITextFieldProps, 'type'> {
  email?: string;
  mobilePhoneNumber?: string;
  className?: string;
  passwordMatchContainerClass?: string;
  maskText?: boolean;
}

const PasswordField: React.FC<IPasswordFieldProps> = ({ mobilePhoneNumber, email, ...props }) => {
  const classes = useStyles();
  const { className, passwordMatchContainerClass, maskText } = props;
  return (
    <div className={`${classes.container} ${className ? className : ''}`}>
      <TextField {...props} type={maskText ? 'text' : 'password'} />
      <PasswordStrengthChecker
        password={props.value || ''}
        email={email}
        mobilePhoneNumber={mobilePhoneNumber}
        className={`${classes.passwordMatchContainer} ${passwordMatchContainerClass || ''}`}
      />
    </div>
  );
};

export default PasswordField;
